export default "__VITE_ASSET__6nc6Po_6__"